import axios, { AxiosRequestConfig } from "axios";
import ApiService from "./apiService";
import EncompassService from "./encompassService";
import AuthService from "./authService";
const useProxy = false;
class IntegrationService {

    
    private apiService: ApiService;
    constructor() {
        this.apiService = ApiService.getInstance(EncompassService.getRequestEndpoint() as string);
    }

    public async get<T>(token: string | null, route: string, configurationId: string): Promise<T> {

        try {
            
            const config: AxiosRequestConfig = {
                headers: {
                    'Authorization': `Bearer ${token}`
                },
                params: {
                    configurationId: configurationId,
                }
            }

            let response;
            if (useProxy) {
                const getRoute = `${EncompassService.getRequestEndpoint()}/${route}?token=${encodeURIComponent((await new  AuthService().getToken()).access_token as string)}&configId=${encodeURIComponent(configurationId)}`;
                response = await axios.get(getRoute);
            } else
                response = await this.apiService.get(`/${route}`, config);
            return response.data as T;
        } catch (error) {
            console.error('Error Fetching Config:', error);
            throw error;
        }
    }

    public async post<T>(token: string | null, route: string, data: any): Promise<T> {
        try {
            const config: AxiosRequestConfig = {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            }

            let response;
            if (useProxy) {
                const postRoute = `${EncompassService.getRequestEndpoint()}/${route}?token=${encodeURIComponent((await new AuthService().getToken()).access_token as string)}`;
                response = await axios.post(postRoute, data);
            } else {
                response = await this.apiService.post(`/${route}`, data, config);
            }
            return response.data as T;
        } catch (error) {
            console.error('Error posting data:', error);
            throw error;
        }
    }
}

export default IntegrationService;